import { ISocialPlatform } from '@/interfaces/socials'
import { User } from 'containers/user/types/user'

export interface Highlight {
  id: string
  image: string
  contentType: HighlightPostContentType
  // published?: boolean -- deprecated
  title: string
  contentLink?: string
  type: HighlightContentType
  stats?: HighlightContentStats[]
  about?: string
  contentCategories?: string[]
  createdOn: Date
  updatedOn: Date
  contentPlatform?: ISocialPlatform | 'web'

  projects?: string[]
}

export enum HighlightPostContentType {
  POST = 'post',
  REEL = 'reel',
  STORY = 'story',
  TIKTOK = 'tiktok',
  YT_SHORT = 'yt_short',
  YT_VIDEO = 'yt_video',
  VIDEO = 'video',
  OTHER = 'other',
}

export enum HighlightContentType {
  ENGAGEMENT = 'Engagement',
  CLICK = 'Click-Through',
  REACH = 'Reach',
  BRAND = 'Brand',
}

export enum HighlightContentStatsName {
  REACH = '🌎 Reach',
  LIKES = '👍 Likes',
  ENGAGEMENT = '😀 Engagement',
  IMPRESSIONS = '📣 Impressions',
  SHARES = '🤲  Shares',
  COMMENTS = '💬 Comments',
  SAVES = '💾 Saves',
  VIDEO_VIEWS = '🎥  Video Views',
  REPLIES = '💬 Replies',
  EXITS = '❌ Exits',
  PLAYS = '⏯️ Plays',
  INTERACTIONS_TOTAL = '🗣️ Interactions (total)',
  VIEWS = '👀 Views',
  DISLIKES = '👎 Dislikes',
}

export interface HighlightContentStats {
  name: HighlightContentStatsName
  value: number
  visible: boolean
}

export interface HighlightEditorStore {
  highlight: Partial<Highlight>
  errors?: HighlightEditorErrors[]
  uploadImageRequired?: boolean
  setHighlight: (highlight: Partial<Highlight>) => void
  updateHighlight: (highlight: Partial<Highlight>) => void
  setErrors: (errors: HighlightEditorErrors[]) => void
  setUploadImageRequired: (required: boolean) => void
  validateHighlight: (highlight: Partial<Highlight>) => boolean
}

export interface HighlightEditorErrors {
  label: keyof Highlight
  message: string
}

export interface HighlightViewDTO {
  highlightId: string
  highlightOwnerId: string
  detailView?: boolean
  viewerId?: string
}

export interface HighlightVieRequestParams {
  ownerProfile: User
  highlight: Highlight
  viewer?: User
  detailView?: boolean
}
